import { PublicKey } from '@solana/web3.js'
import type { Connection } from '@solana/web3.js'
import { toTokenBalance } from './evm'
import type { TokenBalance } from './types'

const TOKEN_PROGRAM_ID = new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')
const ASSOCIATED_TOKEN_PROGRAM_ID = new PublicKey('ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL')

export function getAssociatedTokenAddressSync(mint: PublicKey, owner: PublicKey): PublicKey {
	const [address] = PublicKey.findProgramAddressSync(
		[owner.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()],
		ASSOCIATED_TOKEN_PROGRAM_ID
	)
	return address
}

export async function readSplTokenBalance({
	connection,
	owner,
	mint,
	decimals,
	symbol,
}: {
	connection: Connection
	owner: string
	mint: string
	decimals: number
	symbol: string
}): Promise<TokenBalance> {
	const ownerPubkey = new PublicKey(owner)
	const mintPubkey = new PublicKey(mint)
	const ata = getAssociatedTokenAddressSync(mintPubkey, ownerPubkey)

	const accountInfo = await connection.getAccountInfo(ata)
	if (!accountInfo) {
		return toTokenBalance({ symbol, raw: 0n, decimals, tokenAddress: mint })
	}

	const raw = accountInfo.data.readBigUInt64LE(64)
	return toTokenBalance({ symbol, raw, decimals, tokenAddress: mint })
}
